<div class="d-flex justify-content-between align-items-center w-100">

  <div class="d-flex align-items-center gap-3">
    <app-page-header Heading="Email Template" Description="">
    </app-page-header>

    <app-pagination [EnablePageSize]="true" [rowData]="EmailList" (pageSizeChanged)="handlePageSizeChange($event)">
    </app-pagination>
  </div>

  <div class="d-flex align-items-center gap-2">

    <div class="d-flex flex-column align-items-end">
      <select class="form-select form-select-sm" style="width: 200px;" [formControl]="branchIdControl" (change)="Branchsubmit()">
        <option [ngValue]="0">Show All Branches</option>
        <option *ngFor="let branch of branchList" [ngValue]="+branch.key">
          {{ branch.value }}
        </option>
      </select>
      <app-form-errors [control]="branchIdControl"></app-form-errors>
    </div>

    <button class="btn btn-sm btn-primary" (click)="Branchsubmit()" [disabled]="isLoading">
      <span *ngIf="!isLoading">Load</span>
      <span *ngIf="isLoading" class="spinner-border spinner-border-sm"></span>
    </button>

    <button class="btn btn-sm btn-primary shadow-sm" (click)="openModal()" [disabled]="isLoading || isSubmitting">
      <i class="bi bi-plus-circle me-1"></i> Add Template
    </button>
  </div>

</div>

<app-color-table [columns]="[
  { colName: 'Template Name', colData: 'tName' },
  { colName: 'Description', colData: 'tDesc' },
  { colName: 'Module Name', colData: 'moduleName' },
  { colName: 'Sub-Module Name', colData: 'subModuleName' },
  { colName: 'Email Subject', colData: 'aSubject' }]" [tableData]="EmailList" [enableActionColumn]="true"
  [actionColumnLabel]="'Action'" [actionOptions]="[
  { actionName : 'View', actionIcon: 'fa fa-eye'},
  { actionName : 'Edit', actionIcon: 'fa fa-edit '},
  { actionName: 'Delete', actionIcon: 'fa fa-trash' }]" (actionClick)="handleActionClick($event)"
  [DataLoading]="isLoading"
  [enableInlineButton]="{buttonName:'Send Test Email', buttonClass:'btn btn-primary', actionHandler:handleInlineButtonClick}">
</app-color-table>

<app-pagination [EnableNavigation]="true" [rowData]="EmailList" (pageSizeChanged)="handlePageSizeChange($event)">
</app-pagination>


<ng-template #EmailStepperContent>
  <div class="modal-header">
    <h6 class="modal-title">Email Template Wizard</h6>
    <button type="button" class="btn-close btn-close-white" (click)="emailStepperModal.close()"></button>
  </div>

  <div class="modal-body">
    <!-- Step Indicator -->
    <!-- Step Indicator -->
    <div class="mb-3">
      <ul class="nav nav-tabs custom-tabs">
        <li class="nav-item">
          <span class="nav-link" [class.active]="currentStep === 1" (click)="currentStep = 1">Template Info</span>
        </li>
        <li class="nav-item">
          <span class="nav-link" [class.active]="currentStep === 2" (click)="currentStep = 2">Email Details</span>
        </li>
        <!-- <li class="nav-item">
          <span class="nav-link" [class.active]="currentStep === 3" (click)="currentStep = 3">Email Variables</span>
        </li> -->
      </ul>
    </div>


    <!-- Step 1: Template Info -->
    <div *ngIf="currentStep === 1">
      <form [formGroup]="EmailForm">
        <div class="row">
          <div class="col-md-6 mb-2">
            <label class="form-label">Template Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control form-control-sm" formControlName="tName" />
            <app-form-errors [control]="EmailForm.controls.tName"></app-form-errors>
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Template Description</label>
            <input type="text" class="form-control form-control-sm" formControlName="tDesc" />
            <app-form-errors [control]="EmailForm.controls.tDesc"></app-form-errors>
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Module Name</label>
            <select class="form-select form-select-sm" formControlName="moduleName">
              <option *ngFor="let module of moduleList" [value]="module.value">{{ module.value }}</option>
            </select>
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Sub Module Name</label>
            <input type="text" class="form-control form-control-sm" formControlName="subModuleName" />
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Data Source Type</label>
            <app-valuelist-selector [control]="EmailForm.controls.dataSourceType"
              [vlCode]="'ANNDST'"></app-valuelist-selector>
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Post Data Source Type</label>
            <app-valuelist-selector [control]="EmailForm.controls.postDataSourceType"
              [vlCode]="'ANNPSDST'"></app-valuelist-selector>
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Data Source Definition</label>
            <textarea class="form-control" rows="5" formControlName="dataSourceDefination"></textarea>
          </div>

          <div class="col-md-6 mb-2">
            <label class="form-label">Post Data Source Definition</label>
            <textarea class="form-control" rows="5" formControlName="postDataSourceDefination"></textarea>
          </div>
        </div>
      </form>
    </div>

    <!-- Step 2: Email Details -->
    <div *ngIf="currentStep === 2">
      <form [formGroup]="EmailForm">
        <div class="row">
          <div class="col-md-4 mb-2">
            <label>Email TO</label>
            <input type="email" class="form-control form-control-sm" formControlName="emailTO" />
          </div>

          <div class="col-md-4 mb-2">
            <label>CC TO</label>
            <input type="email" class="form-control form-control-sm" formControlName="ccTo" />
          </div>

          <div class="col-md-4 mb-2">
            <label>BCC TO</label>
            <input type="email" class="form-control form-control-sm" formControlName="bccTo" />
          </div>

          <div class="col-md-6 mb-2">
            <label>Email Config</label>
            <select class="form-select form-select-sm" formControlName="emailConfigId">
              <option *ngFor="let config of emailConfigList" [value]="config.emailConfigId">{{ config.iName }}</option>
            </select>
          </div>

          <div class="col-md-6 mb-2">
            <label>DB Connection ID</label>
            <select class="form-select form-select-sm" formControlName="DBConfig">
              <option *ngFor="let config of emailDBList" [value]="config.dbConnId">{{ config.dbName }}</option>
            </select>
          </div>

          <div class="col-md-10 mb-2">
            <label>Subject</label>
            <input type="text" class="form-control form-control-sm" formControlName="aSubject" />
          </div>

          <div class="col-md-2">
            <!-- <button class="btn btn-primary btn-sm mt-3" [disabled]="loadingAITemplate" (click)="generate()">
              <ng-container *ngIf="!loadingAITemplate; else loadingTpl">
                Generate with AI <i class="bi bi-stars"></i>
              </ng-container>
              <ng-template #loadingTpl>
                <span class="me-2">Generating</span>
                <i class="bi bi-stars animate-stars"></i>
              </ng-template>
            </button> -->


          </div>


          <div class="col-md-12 mb-2">
            <label>Body</label>
            <app-rich-text-editor [control]="EmailForm.controls.aBody"></app-rich-text-editor>
          </div>
        </div>
      </form>
    </div>

    <!-- Step 3: Email Variables -->
    <!-- <div *ngIf="currentStep === 3">
      <form [formGroup]="EmailVariableForm">
        <div class="row mb-2">
          <div class="col-md-4 mb-2">
            <label>Var Instance</label>
            <input type="text" class="form-control form-control-sm" formControlName="varInstance" />
          </div>

          <div class="col-md-4 mb-2">
            <label>Var Value</label>
            <input type="text" class="form-control form-control-sm" formControlName="varValue" />
          </div>

          <div class="col-md-4 mb-2">
            <label>Var Type</label>
            <select class="form-select form-select-sm" formControlName="varType">
              <option value="" disabled>Select Var Type</option>
              <option *ngFor="let type of varTypeOptions" [value]="type.value">{{ type.label }}</option>
            </select>
          </div>
        </div>

        <div class="row">
          <app-color-table [columns]="[
              { colName: 'Var Instance', colData: 'varInstance' },
              { colName: 'Var Value', colData: 'varValue' },
              { colName: 'Var Type', colData: 'varType' }
            ]" [tableData]="emailVariableList" [enableActionColumn]="true" [actionColumnLabel]="'Action'"
            [actionOptions]="[
              { actionName: 'Edit Email Variables', actionIcon: 'fa fa-edit' },
              { actionName: 'Delete', actionIcon: 'fa fa-trash' }
            ]" enableBadge="Template Name" (actionClick)="handleActionClick2($event)">
          </app-color-table>
        </div>
      </form>
    </div> -->

    <!-- Navigation Buttons -->
    <div class="modal-footer">
      <button *ngIf="currentStep > 1" class="btn btn-sm btn-secondary" (click)="previousStep()">Back</button>
      <button *ngIf="currentStep < 2" class="btn btn-sm btn-primary" (click)="nextStep()">Next</button>
      <button *ngIf="currentStep === 2" class="btn btn-sm btn-success" (click)="submitAllForms()"
        [disabled]="isSubmitting">
        <ng-container *ngIf="!isSubmitting; else submittingContent">Finish</ng-container>
        <ng-template #submittingContent>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Submitting...
        </ng-template>
      </button>
      <button class="btn btn-sm btn-secondary" (click)="emailStepperModal.close()">Close</button>
    </div>
  </div>
</ng-template>


<ng-template #SendEmailForm>

  <div class="modal-header">
    <h6 class="modal-title mb-0">
      {{ EmailForm.value.tName }}
    </h6>

    <div class="d-flex align-items-center gap-2">
      <!-- Edit (Pencil) Button -->
      <button type="button" class="btn btn-sm" title="Edit" (click)="isUniversalEditing= !isUniversalEditing">
        <i class="bi bi-pencil text-light"></i>
      </button>

      <!-- Close Button -->
      <button type="button" class="btn-close btn-close-white" aria-label="Close"
        (click)="addSendModel.close()"></button>
    </div>
  </div>


  <div class="modal-body ">
    <form [formGroup]="EmailForm">
      <div class="row">
        <div class="col-md-4 mb-2">
          <label>Email TO</label>
          <input type="email" class="form-control form-control-sm" formControlName="emailTO" />
        </div>

        <div class="col-md-4 mb-2">
          <label>CC TO</label>
          <input type="email" class="form-control form-control-sm" formControlName="ccTo" />
        </div>

        <div class="col-md-4 mb-2">
          <label>BCC TO</label>
          <input type="email" class="form-control form-control-sm" formControlName="bccTo" />
        </div>

        <div class="col-md-6 mb-2">
          <label>Send From</label>
          <select class="form-select form-select-sm" formControlName="emailConfigId">
            <option *ngFor="let config of emailConfigList" [value]="config.emailConfigId">{{ config.iName }}</option>
          </select>
        </div>

        <div class="col-md-6 mb-2">
          <label>DB Connection ID</label>
          <select class="form-select form-select-sm" formControlName="DBConfig">
            <option *ngFor="let config of emailDBList" [value]="config.dbConnId">{{ config.dbName }}</option>
          </select>
        </div>

        <div class="col-md-10 mb-2">
          <label>Subject</label>
          <input type="text" class="form-control form-control-sm" formControlName="aSubject" />
        </div>

        <div class="col-md-2">



        </div>


        <div class="col-md-12 mb-2">
          <label>Body</label>
          <app-rich-text-editor [control]="EmailForm.controls.aBody"></app-rich-text-editor>
        </div>
      </div>
    </form>
    <div class="modal-footer text-end">
      <button class="btn btn-sm btn-primary" (click)="onSubmitAction()" [disabled]="sendEmailLoader">
        <ng-container *ngIf="!sendEmailLoader; else sendingContent">Send Email</ng-container>
        <ng-template #sendingContent>
          <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
          Sending...
        </ng-template>
      </button>
      <button class="btn btn-sm btn-secondary" (click)="addSendModel.close()">Close</button>
    </div>
  </div>
</ng-template>


<!-- ── View Template Modal ─────────────────────────────── -->
<ng-template #ViewEmailContent>
  <div class="modal-header">
    <h6 class="modal-title">
      <i class="fa fa-eye me-2"></i>{{ selectedTemplate?.tName }}
    </h6>
    <button type="button" class="btn-close btn-close-white" (click)="viewModal.close()"></button>
  </div>
  <div class="modal-body p-0">
    <div class="d-flex gap-3 px-3 py-2 bg-light border-bottom flex-wrap" style="font-size:.8rem;color:#6b7280;">
      <span><strong>Module:</strong> {{ selectedTemplate?.moduleName }} / {{ selectedTemplate?.subModuleName }}</span>
      <span><strong>Subject:</strong> {{ selectedTemplate?.aSubject }}</span>
      <span *ngIf="selectedTemplate?.emailTO"><strong>TO:</strong> {{ selectedTemplate?.emailTO }}</span>
    </div>
    <div class="p-3" style="background:#f4f5f7;min-height:300px;">
      <iframe style="width:100%;min-height:500px;border:none;border-radius:6px;background:#fff;"
        [srcdoc]="selectedTemplate?.aBody || ''">
      </iframe>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-sm btn-secondary" (click)="viewModal.close()">Close</button>
  </div>
</ng-template>